module.exports = __webpack_public_path__ + "static/media/Ishank.490e27ca.jpeg";